import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Get cards List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardsgetCards
*/
export const cards = payload => {
	return httpClient({
		method: 'GET',
		url: 'cards/getCards',
		params: payload,
		isCancellable: true
	})
}

/** Creates the url for card image
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cards%7Bid%7Dimage
*/
export const createCardImageUrl = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `cards/${payload}/image`
	})
}

/** Get card movements
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cards%7Bid%7DmovementsV2
*/
export const requestCardMovements = (payload) => {
	return httpClient({
		method: 'GET',
		url: `cards/${payload.cardId}/movementsV2`,
		params: payload.params,
		isCancellable: true
	})
}

/** Cancels Card
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_cards%7Bid%7Dcancel
*/
export const cancelCard = ({ data, id }) => {
	return httpClient({
		method: 'PUT',
		url: `cards/${id}/cancel`,
		data: data,
		operationTypeId: 54 /* for mocks handling of tokens */
	})
}

/** Block a Card
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_cards%7Bid%7Dblock
*/
export const blockCard = ({ params, id }) => {
	return httpClient({
		method: 'PUT',
		url: `cards/${id}/block`,
		params: params
	})
}

/** Unblock a Card
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_cards%7Bid%7Dunblock
*/
export const unblockCard = ({ params, id }) => {
	return httpClient({
		method: 'PUT',
		url: `cards/${id}/unblock`,
		params: params,
		operationTypeId: 5028 /* for mocks handling of tokens */
	})
}

/** Update Card Description
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_cards
*/
export const updateCardDescription = payload => {
	return httpClient({
		method: 'PUT',
		url: 'cards',
		data: payload
	})
}

/** Request Card Moviment Detail
@docs Não há documentação
*/
export const requestMovimentDetail = payload => {
	return httpClient({
		method: 'GET',
		url: `/cards/${payload.cardId}/movement/generic`,
        params: payload.params,
		isCancellable: true
	})
}

/** Get all Cards Types
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardstype
*/
export const getCardsType = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'cards/type',
        params: payload,
		isCancellable: true
	})
}

/** Get all Card Commissions
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardscommissions
*/
export const getCardCommissions = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'cards/commissions',
        params: payload,
		isCancellable: true
	})
}

/** Creates the url to download card cancelation operation receipt/exctrat pdf
*/
export const createDownloadCardCancelExtractPdf = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `cards/cancel/${payload.operationId}/extract`
	})
}

/** Requests security hidden info for card
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cards%7Bid%7Dsecurityelements
*/
export const requestSecurityInfoForCard = id => {
	return httpClient({
		method: 'GET',
		url: `cards/${id}/security/elements`,
		operationTypeId: 5036 /* for mocks handling of tokens */
	})
}

/** Requests Card Limit
@docs Não há documentação
*/
export const requestCardLimit = payload => {
	return httpClient({
		method: 'GET',
		url: `cards/${payload}/limit`,
		isCancellable: true
	})
}

/** Edits Card Limit to a new amount
@docs Não há documentação
*/
export const editCardLimit = payload => {
	return httpClient({
		method: 'PUT',
		url: `cards/${payload.id}/limit`,
		data: payload.data,
		operationTypeId: 5033 /* for mocks handling of tokens */
	})
}

/** Removes current card limit
@docs Não há documentação
*/
export const deleteCardLimit = payload => {
	return httpClient({
		method: 'DELETE',
		url: `cards/${payload}/limit`,
		operationTypeId: 5032 /* for mocks handling of tokens */
	})
}

/** Anticipate Credit Card Payment
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_cardsanticipateCreditPayment
*/
export const anticipateCreditPayment = payload => {
	return httpClient({
		method: 'POST',
		url: 'cards/anticipateCreditPayment',
		data: payload,
		operationTypeId: 5025 /* for mocks handling of tokens */
	})
}

/** Validates Cards Quantity for request
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardsvalidateQuantity
*/
export const validateQuantityForRequest = payload => {
	return httpClient({
		method: 'GET',
		url: 'cards/validateQuantity',
		params: payload,
		isCancellable: true
	})
}

/** Request New Card Solicitation
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_cardssolicitationrequest
*/
export const requestNewCardSolicitation = payload => {
	return httpClient({
		method: 'POST',
		url: 'cards/solicitation/request',
		data: payload,
		operationTypeId: 5037 /* for mocks handling of tokens */
	})
}

/** Validate Card Pan and returns it's info
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cards%7BcardPAN%7Dvalidate
*/
export const validateCardPan = payload => {
	return httpClient({
		method: 'GET',
		url: `cards/${payload}/validate`
	})
}

/** Activate Card
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_cards%7B%7BcardPAN%7D%7Dactivate
*/
export const activateCard = payload => {
	return httpClient({
		method: 'POST',
		url: `cards/${payload}/activate`,
		operationTypeId: 5026 /* for mocks handling of tokens */
	})
}

/** Get Cards Solicitations List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardssolicitationlist
*/
export const getCardsSolicitationsList = payload => {
	return httpClient({
		method: 'GET',
		url: 'cards/solicitation/list',
		params: payload
	})
}

/** Charge Card
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_cards%7BcardNumber%7Dtopup
*/
export const chargeCard = payload => {
	return httpClient({
		method: 'POST',
		url: `cards/${payload.cardId}/topup`,
		data: payload.data,
		operationTypeId: 500016 /* for mocks handling of tokens */
	})
}

/** Get topups list
@docs Não há documentação
*/
export const getTopupsList = payload => {
	return httpClient({
		method: 'GET',
		url: 'cards/topup/list',
		params: payload
	})
}

/** Get available topup plafond for a specific card
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_cards%7BcardNumber%7DavailableTopupPlafond
*/
export const getAvailableTopupPlafond = payload => {
	return httpClient({
		method: 'GET',
		url: `cards/${payload.cardId}/availableTopupPlafond`,
		params: payload.params,
		isCancellable: true
	})
}

/** Get topups transfer details
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardstopuptransferdetails
*/
export const getTopupsTransferDetails = payload => {
	return httpClient({
		method: 'GET',
		url: 'cards/topup/transfer/details',
		params: payload
	})
}
